import { KeyboardBackspaceRounded } from '@mui/icons-material';
import { ReactElement, useCallback } from 'react';

// Components.
import { Button, Link } from 'components';

// Core.
import { ButtonVariant } from 'core';

// Hooks.
import { useClickEvent } from 'hooks';

// Styles.
import styles from './SearchContext.module.scss';

// Types.
import { SearchTypes } from '..';

interface ISearchContent {
  onChange(searchType: SearchTypes): void;
  searchType: SearchTypes;
}

export const SearchContext = ({ onChange, searchType }: ISearchContent): ReactElement => {
  const fireEvent = useClickEvent();

  const handleChange = useCallback(
    (e): void => {
      onChange(e.target.value);
    },
    [onChange],
  );

  return (
    <div className={styles.container}>
      <div className={styles.selector}>
        {/* toggles search paramaters */}
        <input
          defaultChecked={searchType === SearchTypes.Specialty}
          id="specialtySearchRadio"
          type="radio"
          name="searchContext"
          onChange={handleChange}
          value={SearchTypes.Specialty}
        />
        <label htmlFor="specialtySearchRadio">Specialty Search</label>
        <input
          defaultChecked={searchType === SearchTypes.Keyword}
          id="keywordSearchRadio"
          type="radio"
          name="searchContext"
          onChange={handleChange}
          value={SearchTypes.Keyword}
        />
        <label htmlFor="keywordSearchRadio">Keyword Search</label>
      </div>
      <div className={styles.buttons}>
        {/* Link to CME Finder Activity Search */}
        <Button
          component={Link}
          onClick={() => fireEvent({ EventAction: 'Links', EventLabel: 'Browse All Activities' })}
          to="/activity/search"
          variant={ButtonVariant.Secondary}
        >
          Browse All Activities
          <KeyboardBackspaceRounded />
        </Button>
      </div>
    </div>
  );
};
